var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"title":"Calculo del precio","hide-footer":"","size":"md","id":"final-price-description"}},_vm._l((_vm.price_descriptions),function(des){return _c('div',[(des === des.toUpperCase())?_c('div',[_c('hr'),_c('h4',[_vm._v(" "+_vm._s(des)+" ")]),_c('hr')]):_c('p',[_vm._v(" "+_vm._s(des)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }